import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { CookieService } from "ngx-cookie-service";
import { ComponentMenuBar } from '../../component-ui/menu-bar/component';
var LearningCampComponent = (function () {
    function LearningCampComponent(route, router, apiService, cookieService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.cookieService = cookieService;
        this.commonService = commonService;
        this.campName = "";
        this.assetsRoute = "../../assets";
        this.progress = 0;
        this.isPC = false;
        this.isShowIntroduction = false;
        this.startEvent = false; //开始记录event,防止在返回按钮时又调用一次event
        this.isShowReport = false;
        this.isShowTip = false;
        this.isCampEnd = false;
        this.isShowGDPR = false;
        this.gdprStatus = "";
        this.count = 0;
        this.isShowWechatNotice = false;
        this.isShowToast = false;
        this.campToast = "";
        this.loadFinished = false;
        this.isHaveTools = false;
        this.isShowGuide = false;
        this.startDayTitle = "";
        this.startDayCon = "";
        this.circleTheme = {
            'width': 300,
            'height': 300,
            'x': 0,
            'y': 0,
            'radius': 90,
            'innerRadius': 20,
            'startAngle': 0,
            'endAngle': 360,
            'angleRadian': 275,
            'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
        }; //主题
    }
    LearningCampComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.skuId = params['skuId'];
            _this.campId = Number(params['campId']);
            _this.methodId = params['methodId'] ? params['methodId'] : null;
            _this.assetsRoute = _this.commonService.setAssetsRoute(_this.assetsRoute);
            _this.isPC = !!localStorage.getItem('isPC');
            _this.projectId = localStorage.getItem("projectId");
            _this.getTrainingCampCourse(_this.skuId).then(function (result) {
                console.log(result);
                _this.campTour = result;
                // this.campName = result.name;
                _this.campName = result['campName'];
                _this.userId = result['userId'];
                _this.campTourMetas = result['campMetasLearningPathMetasRelations'];
                if (_this.campTourMetas[0].learningPathMetasId === -40401 || _this.campTourMetas[0].learningPathMetasId === -42401) {
                    _this.startDayTitle = _this.campTourMetas[0].pathTitle;
                    _this.startDayCon = _this.campTourMetas[0].pathName;
                }
            })
                .then(function () {
                return _this.getUserExerciseBookAPI(0, 0).then(function (result) {
                    return _this.exerciseBook = result;
                });
            }).then(function () {
                return _this.getLastActualOperationAPI(_this.campId).then(function (result) {
                    return _this.AO = result;
                });
            }).then(function () {
                return _this.getUserHaveTools().then(function (result) {
                    return _this.isHaveTools = result;
                });
            }).then(function () {
                return _this.commonService.getOnceIno(99999).then(function (result) {
                    return _this.isShowGuide = result !== 1;
                });
            })
                .then(function () {
                // let type = this.report.achievementLvl === -1 ? 7 : 8;
                var type = 7;
                return _this.commonService.getOnceIno(_this.commonService.getOnceValue(_this.skuId, type)).then(function (result) {
                    return _this.onceResult = result;
                });
            })
                .then(function () {
                _this.loadFinished = true;
                _this.constituteId = _this.AO['constituteId'];
                // this.isCampEnd = this.report.achievementLvl === -1 ? false : true;
                // this.isShowIntroduction = this.isCampEnd ? false : this.onceResult === 1 ? false : true;
                if (_this.onceResult !== 1) {
                    _this.isShowIntroduction = true;
                    _this.startEvent = true;
                    _this.apiService.learingTime({ module: _this.campTour.campName + "训练营", type: 1, btnName: '训练营介绍页', courseUnit: Number(_this.skuId), userId: _this.userId }).subscribe(function (result) {
                        console.log("开始记录介绍页的埋点", result);
                    });
                }
                // this.isShowReport = this.isCampEnd ? this.onceResult === 1 ? false : true : false;
                _this.setProgressInLearningTour();
            });
        });
        //训练营心跳清除数据
        if (localStorage.getItem("learningPathMetasId")) {
            localStorage.removeItem("learningPathMetasId");
        }
        if (localStorage.getItem("learningPathMetaId")) {
            localStorage.removeItem("learningPathMetaId");
        }
        $('#learningPathMetaIdContainer').val("");
    };
    ;
    LearningCampComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#F2F3FA'
        });
    };
    //获取用户所有训练营下面的练习册
    LearningCampComponent.prototype.getUserExerciseBookAPI = function (campId, status) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/applicationPractice/exerciseBook?campMetasId=' + campId + '&status=' + status
        }).toPromise();
    };
    //获取day7的实战作业
    LearningCampComponent.prototype.getLastActualOperationAPI = function (campId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/lastDay/' + campId
        }).toPromise();
    };
    //获取训练营课程
    LearningCampComponent.prototype.getTrainingCampCourse = function (skuId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/everyDayTask/' + skuId
            // 'url': 'sr/learningTourTrainingCamp/'+skuId
        }).toPromise();
    };
    /**
     *校验用户是否有小工具权限
     */
    LearningCampComponent.prototype.getUserHaveTools = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/tools/yyToolsLibrary/haveToolsAuthority'
        }).toPromise();
    };
    //将进度数据插入learningTour
    LearningCampComponent.prototype.setProgressInLearningTour = function () {
        var _this = this;
        this.getUserCampProgress(this.campId).then(function (result) {
            _this.progressLists = result;
        }).then(function () {
            for (var i = 0, len = _this.campTourMetas.length; i < len; i += 1) {
                _this.campTourMetas[i].progress = _this.progressLists.length !== 0 ? _this.progressLists[i]['progress'] : 0;
            }
        });
    };
    //进入实战作业
    LearningCampComponent.prototype.goActualCombatWork = function () {
        if (this.AO['status'] < 20) {
            if (this.methodId) {
                this.router.navigate(["exercise-work", this.constituteId], { queryParams: { "isLastDay": 1, "onlyCamp": 1 } });
            }
            else {
                this.router.navigate(["exercise-work", this.constituteId], { queryParams: { "isLastDay": 1 } });
            }
        }
        else {
            console.log(this.methodId);
            if (this.methodId) {
                this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: 0, 'constituteId': this.constituteId, "onlyCamp": 1, "isLastDay": 1 } }).then();
            }
            else {
                this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: 0, 'constituteId': this.constituteId, "isLastDay": 1 } }).then();
            }
        }
    };
    /**
     * 进入工具
     */
    LearningCampComponent.prototype.goTools = function () {
        this.isShowGuide = false;
        this.menuBar.goTools();
    };
    //进入能力列表
    LearningCampComponent.prototype.goLearnPath = function (learningMetaId, index, flag) {
        var _this = this;
        if (this.isShowToast) {
            return;
        }
        else {
            this.campToast = "这位积极的同学，此部分课程将在<br />" + this.campTourMetas[index < 0 ? this.campTourMetas.length - 1 : index]['trainingCampLockDate'] + "准时解锁！";
            localStorage.setItem("campCourseDay", this.campTourMetas[index < 0 ? this.campTourMetas.length - 1 : index]['pathTitle']);
            if (!flag) {
                if (index == 0) {
                    var learningMetaIdValue = Math.abs(learningMetaId); //取绝对值
                    var learningMetaIds = Number(String(learningMetaIdValue).slice(0, String(learningMetaIdValue).length - 2));
                    if (this.campId === 2) {
                        learningMetaIds = 414; //因为互联网没有day0和day14所以不需要截取
                    }
                    //day0
                    this.router.navigate(['learning-path', learningMetaIds], { queryParams: { firstDay: 1 } });
                    localStorage.setItem('learningPathMetasId', this.campTourMetas[0]['learningPathMetasId']);
                    // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[0].sort);
                }
                else if (index < 0) {
                    var learningMetaIdValue = Math.abs(learningMetaId); //取绝对值
                    var learningMetaIds = Number(String(learningMetaIdValue).slice(0, String(learningMetaIdValue).length - 2));
                    if (this.campId === 2) {
                        learningMetaIds = 414; //因为互联网没有day0和day14所以不需要截取
                    }
                    //day14
                    this.router.navigate(['learning-path', learningMetaIds], { queryParams: { isLastDay: 1 } });
                    localStorage.setItem('learningPathMetasId', this.campTourMetas[this.campTourMetas.length - 1]['learningPathMetasId']);
                    // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[this.campTour.campMetasLearningPathMetasRelations.length-1].sort);
                }
                else {
                    this.router.navigate(['learning-path', learningMetaId]);
                    // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[index].sort);
                }
            }
            else {
                this.isShowToast = true;
                setTimeout(function () {
                    _this.isShowToast = false;
                }, 2000);
            }
        }
    };
    //根据条件在数组中获取下标
    LearningCampComponent.prototype.getIndexByConditionIdInLists = function (Lists, condition, value) {
        return (Lists || []).findIndex(function (v) { return v[condition] === value; });
    };
    //获取用户进度
    LearningCampComponent.prototype.getUserLearningProgress = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress',
        }).toPromise();
    };
    /**
     * 获取训练营课程进度
     * @param campId:Number  训练营Id
     */
    LearningCampComponent.prototype.getUserCampProgress = function (campId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/dayProgress?campMetaId=' + campId
        }).toPromise();
    };
    //获取用户结业报告
    LearningCampComponent.prototype.getUserGraduateReport = function (userId, skuId) {
        return this.apiService.ajax({
            'type': 'GET',
            // 'url': 'http://m-uat.transtalent.cn/ddilearner/v1/camp/achievement/'+userId+'/'+skuId
            'url': 'ddilearner/v1/camp/achievement/' + userId + '/' + skuId
        }).toPromise();
    };
    //显示旅程地图
    LearningCampComponent.prototype.showEnterAnimate = function () {
        this.isShowIntroduction = true;
        this.commonService.learningPortEventLog({
            "eventType": "introduction_learning_journey",
            "eventSubType": ""
        }).then();
    };
    //显示结营回顾
    LearningCampComponent.prototype.showEnterReport = function () {
        this.isShowReport = true;
        this.commonService.learningPortEventLog({
            "eventType": "journey_review",
            "eventSubType": ""
        }).then();
    };
    //关闭旅程地图
    LearningCampComponent.prototype.closeLearningCampIntroduction = function () {
        this.isShowIntroduction = false;
        if (this.startEvent) {
            this.apiService.learingTime({ module: this.campTour.version + this.campTour.campName + "训练营", type: 2, btnName: '训练营介绍页', userId: this.userId }).subscribe(function (result) {
                console.log("开始记录介绍页的埋点", result);
            });
        }
    };
    //关闭结营仪式
    LearningCampComponent.prototype.closeLearningCampReport = function () {
        this.isShowReport = false;
    };
    LearningCampComponent.prototype.goToLearningMap = function () {
        // this.router.navigate(['learning-map']);
        if (this.projectId) {
            this.router.navigate(['learning-project', this.projectId]);
        }
        else {
            this.router.navigate(['learning-map']);
        }
    };
    // 显示提示框
    LearningCampComponent.prototype.showComponentTip = function () {
        this.isShowTip = true;
    };
    // 关闭提示框
    LearningCampComponent.prototype.closeComponentTip = function () {
        this.isShowTip = false;
        this.menuBar.showOrCloseFullPage();
    };
    //关闭GDPR
    LearningCampComponent.prototype.closeGDPR = function () {
        var _this = this;
        this.isShowGDPR = false;
        this.gdprStatus = "";
        setTimeout(function () {
            _this.menuBar.showOrCloseFullPage();
        }, 100);
    };
    //显示GDPR
    LearningCampComponent.prototype.showGDPR = function () {
        var _this = this;
        this.isShowGDPR = true;
        setTimeout(function () {
            _this.gdprStatus = "open";
        }, 100);
    };
    //微信提醒按钮
    LearningCampComponent.prototype.showWechatNotice = function () {
        this.count++;
        if (this.count > 20) {
            this.isShowWechatNotice = true;
            this.count = 0;
        }
    };
    LearningCampComponent.prototype.menuBarClick = function () {
        this.menuBar.showOrCloseFullPage();
    };
    LearningCampComponent.prototype.closeWechatNotice = function () {
        this.isShowWechatNotice = false;
    };
    // 登出
    LearningCampComponent.prototype.logout = function () {
        var _this = this;
        this.apiService.logout().subscribe(function (res) {
            if (res) {
                console.log(res, '登出接口');
                _this.isShowTip = false;
                //清除多公司记录
                _this.commonService.clearLoginCredentials();
                localStorage.removeItem('themeBG');
                localStorage.removeItem('userId');
                localStorage.removeItem('transtalen-token');
                localStorage.removeItem('transtalenuserid');
                _this.router.navigate(['new-login']);
            }
        });
    };
    return LearningCampComponent;
}());
export { LearningCampComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/learning-camp.component.ts.pre-build-optimizer.js